import { styled } from 'styled-components';

import { _useDispatch, _useSelector } from '@src/state/hooks';

import _createGame from '@src/io/events_out/_createGame';

import _joinGame from '@src/io/events_out/_joinGame';
import _watchGame from '@src/io/events_out/_watchGame';
import { GameType } from '@src/lib/types';

import { clearEventQueue } from '@src/state/slices/slice_game';
import { GameState } from '@src/state/slices/types';

import Row from './Row';

const Container = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;

  margin-top: 10pt;
  border: 2pt solid gray;
  padding: 5pt;

  overflow-y: scroll;

  // color hyperlink blue
  color: #0000ff;

  //background color windows 98 gray
  background-color: #c0c0c0;
`;

interface Props {
  games: GameState['games'];
  gameTypes: GameType[];
  showJoinPrivateGamePanel: (
    gameId: string,
    gameName: string,
    gameWager: number,
  ) => void;
  showConfirmJoinGamePanel: (
    gameId: string,
    gameName: string,
    gameWager: number,
  ) => void;
}

export default function GamesList(props: Props) {
  const dispatch = _useDispatch();
  const playerMeta = _useSelector((state) => state.game.playerMeta);
  const playerId = playerMeta?.playerId || '';

  const joinGame = (gameId: string, gameName: string, gameWager: number) => {
    // if wagered, show confirm join game panel
    if (gameWager) {
      props.showConfirmJoinGamePanel(gameId, gameName, gameWager);
    } else {
      dispatch(clearEventQueue());
      _joinGame(gameId);
    }
  };

  const watchGame = (gameId: string) => {
    dispatch(clearEventQueue());
    _watchGame(gameId);
  };

  const games = _useSelector((state) => state.game.games) || [];

  return (
    <Container>
      {Object.values(games)
        .filter((game) => !!game)
        .filter((game) => !(game.terminated || game.gameEnded))
        .filter((game) => props.gameTypes.includes(game.type))
        .map((game) => (
          <Row
            key={game.gameId}
            name={game.name}
            gameId={game.gameId}
            numPlayers={game.numPlayers}
            maxPlayers={10}
            isPublic={game.isPublic}
            gameStarted={game.gameStart}
            gameWager={game.wager ? game.wager : 0}
            gameHost={game.hostPlayerId ? game.hostPlayerId.slice(0, 7) : '??'}
            joinGame={joinGame}
            watchGame={watchGame}
            gameType={game.type}
            playerCanJoin={
              game.whitelist === undefined || game.whitelist.includes(playerId)
            }
            showJoinPrivateGamePanel={props.showJoinPrivateGamePanel}
          />
        ))}
    </Container>
  );
}
